import React from 'react';
import { observer } from 'mobx-react';
import { makeAutoObservable } from 'mobx';
import { CombinedOutlookLocationViewer } from './CombinedSearchResultsStateOutlook';
import { Stack, Text } from '@fluentui/react';
import CombinedSearchResultsEntityNav from './CombinedSearchResultsEntityNav';
import { IContextCommands, IOutlookAppCommands } from '../state/CorporateArchiveStates/LegalEntityDocumentsStateOutlook';
import API, { IUserConfigPackage } from '../API';

export class OutlookTabPinnedItemsState {
	
	public pinned: CombinedOutlookLocationViewer;
	userConfig: IUserConfigPackage;
	commands: IOutlookAppCommands;
	initialLoaded: boolean = false;

	constructor(userConfig: IUserConfigPackage, commands: IOutlookAppCommands){
		this.userConfig = userConfig;
		this.commands = commands;
		this.pinned = new CombinedOutlookLocationViewer(
			userConfig,
			commands,
			this.getCtxCommands(),
		);
		
		makeAutoObservable(this);
		
	}

	public getCtxCommands(): IContextCommands {

		return {
			pin: this.pin.bind(this),
			unpin: this.unpin.bind(this),
			isPinned: this.isPinned.bind(this),
		};

	}

	ensureInitialLoaded() {
		if(!this.initialLoaded) {
			this.initialLoaded = true;
			this.updatePinned();
		}
	}

	public isPinned(entityType: string, id: string, url: string): boolean {
		return this.pinned.contains(entityType, id, url);
	}

	public async pin(entityType: string, id: string, url: string): Promise<void> {
		//Pin the item
		let api = new API(await this.userConfig.getToken());
		await api.pin(entityType, id, url);

		//Refresh pinned items
		await this.updatePinned();
	}

	public async unpin(
		entityType: string,
		id: string,
		url: string,
	): Promise<void> {

		let matching = this.pinned.findMatchingItem(entityType, id, url);
		if(matching) {
			this.pinned.remove(matching);
		}

		//Unpin the item
		let api = new API(await this.userConfig.getToken());
		await api.unpin(entityType, id, url);
	}

	public async updatePinned() {
		this.pinned.setLoading(true);

		let api = new API(await this.userConfig.getToken());
		let pinnedItems = await api.pinned();
		this.pinned.setResults(pinnedItems);
	}

}

export interface IOutlookTabPinnedItemsProps {
	state: OutlookTabPinnedItemsState;
}

class OutlookTabPinnedItems extends React.Component<IOutlookTabPinnedItemsProps,{}> {
	componentDidMount(): void {
		this.props.state.ensureInitialLoaded();
	}

	render(): React.ReactNode {
		if (this.props.state.pinned.allItems?.any || this.props.state.pinned.loading) {
			return (
				<Stack>
					<CombinedSearchResultsEntityNav state={this.props.state.pinned} />
				</Stack>
			);
		} else {
			//There's no items
			return <Text>No favourite locations.</Text>;
		}
	}
}

export default observer(OutlookTabPinnedItems);
